<script>
import {UContextMenu} from 'uloc-vue'
import RemocaoListMenu from './remocao-list-menu'

export default {
  name: 'ContextMenuRemocaoItem',
  props: ['remocao'],
  data () {
    return {
      atualizando: false
    }
  },
  computed: {},
  methods: {
  },
  components: {RemocaoListMenu, UContextMenu}
}
</script>

<template>
  <u-context-menu ref="context" class="erp-context-menu">
    <remocao-list-menu @abrir="$emit('abrir')" />
  </u-context-menu>
</template>
